/**
 * Client-safe settings. These can be imported in both server and client code.
 * Server-only secrets (API keys) are read in `*.server.ts` modules (env.server.ts).
 */

export const GOOGLE_FORMS_FEEDBACK_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSc3Ri8i5xh04HyEDzYYPKbQHW4ykZy-RNNhN7EvkStPMYcAOw/viewform?usp=pp_url&entry.1127168165=AI-assistenten'
